<template>
    <div class="view view--news-create">
        <div class="has-margin-b30">
            <control
                name="titleControl"
                type="text"
                v-bind:label="__('Title')"
                v-model="news.title"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.title != null"
            >
                {{ errors.title[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="tags[]"
                type="tag"
                icon="search"
                label-field="title"
                placeholder="start typing the title of the tag here"
                v-bind:source-search="getTags"
                v-bind:label="__('Tags')"
                v-model="news.tags"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.tags != null"
            >
                {{ errors.tags[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="shortDescriptionControl"
                type="textarea"
                v-bind:label="__('Short description')"
                v-model="news.shortDescription"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.short_description != null"
            >
                {{ errors.short_description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="descriptionControl"
                type="textarea"
                v-bind:label="__('Description')"
                v-model="news.description"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.description != null"
            >
                {{ errors.description[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredVideoControl"
                type="file"
                ref="videoControl"
                v-bind:filename="news.videoUrl"
                v-bind:label="__('Featured video')"
                v-model="news.videoFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredVideo != null"
            >
                {{ errors.featuredVideo[0] }}
            </div>
        </div>
        <div class="has-margin-b30">
            <control
                name="featuredImageControl"
                type="file"
                ref="imageControl"
                v-bind:filename="news.imageUrl"
                v-bind:label="__('Featured image')"
                v-model="news.imageFile"
            />
            <div
                class="has-text-danger has-margin-b10"
                v-if="errors.featuredImage != null"
            >
                {{ errors.featuredImage[0] }}
            </div>
        </div>

        <btn
            class="is-success"
            type="default"
            v-html="__('Create')"
            v-on:click="createNews"
        ></btn>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import NewsRepository from '../../repositories/NewsRepository';
import router from '../../router';
import TagRepository from '../../repositories/TagRepository';

export default {
    components: {
        Btn,
        Control
    },
    created: function() {
        this.newsRepository = new NewsRepository();
        this.tagRepository = new TagRepository();
    },
    data: function() {
        return {
            dateConfig: {
                enableTime: false
            },
            errors: {},
            news: {
                id: null,
                createdAt: null,
                deletedAt: null,
                description: '',
                imageFile: null,
                imageUrl: null,
                shortDescription: '',
                tags: [],
                title: '',
                userId: null,
                updatedAt: null,
                videoFile: null,
                videoUrl: null
            },
            newsRepository: null,
            tagRepository: null
        };
    },
    methods: {
        createNews: async function() {
            try {
                const data = {
                    description: this.news.description,
                    image: this.news.imageFile,
                    imageName: this.$refs.imageControl.selectedFilename,
                    tags: this.news.tags.map(tag => tag.title),
                    title: this.news.title,
                    short_description: this.news.shortDescription,
                    video: this.news.videoFile,
                    videoName: this.$refs.videoControl.selectedFilename
                };

                await this.newsRepository.createNews(data);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('News was successfully created.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await router.push({
                    path: '/news'
                });
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        getTags: async function(search) {
            try {
                const tags = await this.tagRepository.getTags(search);

                if (tags.length === 0) {
                    return [
                        {
                            title: search,
                            id: 0
                        }
                    ];
                }

                return tags;
            } catch (error) {
                return [];
            }
        }
    }
};
</script>
